module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CK - Cook Islands.a489b3f7.svg";